import {
  forwardRef,
  Skeleton,
  SkeletonProps,
  useColorModeValue,
} from "@chakra-ui/react";

export const BrandedSkeleton = forwardRef(
  ({ ...props }: SkeletonProps, ref) => {
    return (
      <Skeleton
        startColor={useColorModeValue("blackAlpha.50", "whiteAlpha.50")}
        endColor={useColorModeValue("blackAlpha.200", "whiteAlpha.200")}
        {...props}
        ref={ref}
      />
    );
  },
);
